module.exports = __webpack_public_path__ + "img/09.b3603510.jpg";